export const UNREPRESENTATIVE_ICON_TEST_ID = 'unrepresentative-icon';
export const MAX_UNREPRESENTATIVE_INDICATOR = 50;
export const MIN_UNREPRESENTATIVE_INDICATOR = 30;
